import { graphql } from "gatsby";
import React, { FC } from "react";

export interface CompanyEventScheduleProps extends Queries.CompanyEventScheduleDataFragment {}

export const CompanyEventSchedule: FC<CompanyEventScheduleProps> = ({ time, description }) => {
  return (
    <div className="flex flex-col md:flex-row gap-2 md:gap-5 font-light">
      <div className="flex-shrink-0 w-10 md:text-right">{time}</div>
      <div>{description}</div>
    </div>
  );
};

export const query = graphql`
  fragment CompanyEventScheduleData on ContentfulCompanyEventSchedule {
    time
    description
  }
`;
